module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14ff0e9e964d43617c7298df4b888d10.png";